module.exports = __webpack_public_path__ + "static/media/revery.29f9ea55.svg";